const textColumnCls = "_yr2tmlmajg";

export { textColumnCls };
import "./TextColumn.linaria.module.css";
//# sourceMappingURL=TextColumn.js.map
